import {constructUsing} from 'rlink-collections/symbols';
import inspectableError from 'rlink-inspectable-error';

/**
 * Returns a function that is called with key and value iterable items
 * and returns whatever value would be required for the constructor
 * of the given obj (either the key, value or both  - as returned by
 * `constructsUsing`).
 *
 * @param  {Collection} obj
 * @return {*}
 */
export default function yieldableFor (obj) {
  let constructsUsing = this.constructsUsing(obj);
  return function yieldable (key, value) {
    switch (constructsUsing) {
      case constructUsing.key:
        return key;
      case constructUsing.value:
        return value;
      case constructUsing.both:
        return [key, value];
      default:
        throw inspectableError`Unknown symbol ${{constructsUsing}}`;
    }
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/yieldableFor.js